<template>
  <el-select
    v-model="bindValue"
    remote
    filterable
    :clearable="false"
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    @change="handleSelectChange"
    :loading="loading"
  >
    <el-option
      v-for="item in options"
      :key="item.hotPointID"
      :label="`${item.name}`"
      :value="item.hotPointID"
    >
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: "DyPoiSearch",
  props: {
    value: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
    },
    city: {
      type: String,
      default: "全国",
    },
    center: {
      type: Array,
    },
    bounds: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
      options: [],
      interval: null,
    };
  },
  computed: {
    bindValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
  },
  methods: {
    remoteMethod(name) {
      if (this.interval) {
        clearTimeout(this.interval);
      }
      this.interval = setTimeout(() => {
        // axios.get(`http://api.tianditu.gov.cn/v2/search?postStr={"keyWord":"${name}","level":12,"queryType":1,"start":0,"count":100}&type=query&tk=d02eaddf056c6f34ad9bd73eeca5f7fa`)
        // axios.get(`http://api.tianditu.gov.cn/v2/search?postStr={"keyWord":"${name}","level":12,"queryType":2,"start":0,"count":10}&type=query&tk=d02eaddf056c6f34ad9bd73eeca5f7fa`)
        // axios.get(`http://api.tianditu.gov.cn/v2/search?postStr={"keyWord":"${name}","level":12,"queryRadius":5000,"pointLonlat":"${this.center.lng},${this.center.lat}","queryType":3,"start":0,"count":10}&type=query&tk=d02eaddf056c6f34ad9bd73eeca5f7fa`) // 中心
        axios.get(`https://api.tianditu.gov.cn/v2/search?postStr={"keyWord":"${name}","level":12,"mapBound":"${this.bounds.Lq.lng},${this.bounds.Lq.lat},${this.bounds.kq.lng},${this.bounds.kq.lat}","queryType":2,"start":0,"count":10}&type=query&tk=d02eaddf056c6f34ad9bd73eeca5f7fa`).then(res => {
          this.options = res.data.pois
        })
      }, 500);
    },
    handleSelectChange(val) {
      const findResult = this.options.find((item) => item.hotPointID === val);
      this.$emit("change", findResult);
    },
  },
};
</script>

<style lang="scss" scoped></style>
